import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from '../status-chart-panel/StatusChartPanel';
import { entityType } from '../../filters/interface-filter/InterfaceFilter';
import { interfaceFilterId, timeRangeFilterId } from '../../filters';

const title = t`Interface Status`;

function InterfaceStatusPanel() {
    return <StatusChartPanel entityType={entityType} />;
}

InterfaceStatusPanel.propTypes = {
    ...panelPropTypes,
};

InterfaceStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 40,
    minContentHeight: 40,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'InterfaceStatusTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.INTERFACE,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected interface`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, interfaceFilterId],
        optional: [],
    },
})(InterfaceStatusPanel);
